module.exports = __webpack_public_path__ + "static/media/edit-pen.027b234f.svg";